<script setup lang="ts">
import type { ContentTextProps } from '@fondof-ui/components/content/types'
import Markdown from '@fondof-ui/components/markdown/Markdown.vue'
import type { HTMLAttributeClass } from '@fondof-ui/types'

const props = defineProps<ContentTextProps & HTMLAttributeClass>()
</script>

<template>
  <div :class="props.class">
    <Markdown
      :set-brand="true"
      :content="props.content"
    />
  </div>
</template>
